// Vocational Training Programs from The Institute of Professional Studies
// These are certificate and diploma programs for professional development

export const vocationalCategories = [
  'Healthcare',
  'Business & Administration',
  'Information Technology',
  'Agriculture & Environment',
  'Education & Training',
];

export const vocationalPrograms = [
  // Healthcare Programs
  {
    id: 'chw',
    name: 'Community Health Worker Certificate',
    shortName: 'CHW',
    category: 'Healthcare',
    level: 'Certificate',
    duration: '6 months',
    description: 'Train to become a frontline healthcare worker providing basic health services and education in communities.',
    modules: [
      'Introduction to Community Health',
      'Disease Prevention and Control',
      'Maternal and Child Health',
      'First Aid and Emergency Care',
      'Health Education Techniques',
      'Community Mobilization',
    ],
  },
  {
    id: 'pha',
    name: 'Pharmacy Assistant Certificate',
    shortName: 'PHA',
    category: 'Healthcare',
    level: 'Certificate',
    duration: '9 months',
    description: 'Learn pharmaceutical dispensing, inventory management, and patient counseling for pharmacy settings.',
    modules: [
      'Introduction to Pharmacy',
      'Pharmaceutical Calculations',
      'Drug Classification and Uses',
      'Dispensing Techniques',
      'Inventory Management',
      'Patient Counseling',
    ],
  },
  {
    id: 'mra',
    name: 'Medical Records Assistant',
    shortName: 'MRA',
    category: 'Healthcare',
    level: 'Certificate',
    duration: '6 months',
    description: 'Manage patient records, health information systems, and medical documentation in healthcare facilities.',
    modules: [
      'Health Information Management',
      'Medical Terminology',
      'Record Keeping Systems',
      'Data Entry and Retrieval',
      'Confidentiality and Ethics',
      'Computer Applications in Health',
    ],
  },
  {
    id: 'dph',
    name: 'Diploma in Public Health',
    shortName: 'DPH',
    category: 'Healthcare',
    level: 'Diploma',
    duration: '12 months',
    description: 'Comprehensive training in public health principles, disease surveillance, and health program management.',
    modules: [
      'Principles of Public Health',
      'Epidemiology Basics',
      'Health Program Planning',
      'Disease Surveillance',
      'Environmental Health',
      'Health Promotion Strategies',
      'Research Methods',
      'Internship',
    ],
  },
  
  // Business & Administration Programs
  {
    id: 'oa',
    name: 'Office Administration Certificate',
    shortName: 'OA',
    category: 'Business & Administration',
    level: 'Certificate',
    duration: '6 months',
    description: 'Develop essential skills for office management, communication, and administrative support.',
    modules: [
      'Office Procedures',
      'Business Communication',
      'Computer Applications (MS Office)',
      'Record Management',
      'Customer Service',
      'Time Management',
    ],
  },
  {
    id: 'acc',
    name: 'Accounting Technician Certificate',
    shortName: 'ACC',
    category: 'Business & Administration',
    level: 'Certificate',
    duration: '9 months',
    description: 'Learn bookkeeping, financial recording, and basic accounting principles for business operations.',
    modules: [
      'Principles of Accounting',
      'Bookkeeping',
      'Financial Statements',
      'Payroll Processing',
      'Tax Basics',
      'Accounting Software',
    ],
  },
  {
    id: 'pm',
    name: 'Project Management Certificate',
    shortName: 'PMC',
    category: 'Business & Administration',
    level: 'Certificate',
    duration: '6 months',
    description: 'Master project planning, execution, and monitoring for successful project delivery.',
    modules: [
      'Project Planning',
      'Budgeting and Cost Control',
      'Team Management',
      'Risk Assessment',
      'Monitoring and Evaluation',
      'Project Documentation',
    ],
  },
  {
    id: 'dbm',
    name: 'Diploma in Business Management',
    shortName: 'DBM',
    category: 'Business & Administration',
    level: 'Diploma',
    duration: '12 months',
    description: 'Comprehensive business management training covering operations, marketing, finance, and leadership.',
    modules: [
      'Principles of Management',
      'Marketing Fundamentals',
      'Financial Management',
      'Human Resource Management',
      'Business Law',
      'Entrepreneurship',
      'Strategic Planning',
      'Capstone Project',
    ],
  },
  
  // Information Technology Programs
  {
    id: 'icl',
    name: 'Computer Literacy Certificate',
    shortName: 'ICL',
    category: 'Information Technology',
    level: 'Certificate',
    duration: '3 months',
    description: 'Foundation course in computer basics, internet usage, and essential software applications.',
    modules: [
      'Computer Basics',
      'Microsoft Word',
      'Microsoft Excel',
      'Microsoft PowerPoint',
      'Internet and Email',
      'Digital Safety',
    ],
  },
  {
    id: 'wdt',
    name: 'Web Development Certificate',
    shortName: 'WDT',
    category: 'Information Technology',
    level: 'Certificate',
    duration: '9 months',
    description: 'Learn to build websites using HTML, CSS, JavaScript, and modern web technologies.',
    modules: [
      'HTML Fundamentals',
      'CSS Styling',
      'JavaScript Basics',
      'Responsive Design',
      'Web Hosting',
      'Portfolio Project',
    ],
  },
  {
    id: 'dit',
    name: 'Diploma in Information Technology',
    shortName: 'DIT',
    category: 'Information Technology',
    level: 'Diploma',
    duration: '12 months',
    description: 'Comprehensive IT training covering hardware, software, networking, and database management.',
    modules: [
      'Computer Hardware',
      'Operating Systems',
      'Networking Basics',
      'Database Management',
      'Programming Fundamentals',
      'Cybersecurity',
      'IT Project Management',
      'Industrial Attachment',
    ],
  },
  
  // Agriculture & Environment Programs
  {
    id: 'agc',
    name: 'Agricultural Extension Certificate',
    shortName: 'AGC',
    category: 'Agriculture & Environment',
    level: 'Certificate',
    duration: '6 months',
    description: 'Train to support farmers with modern agricultural techniques and extension services.',
    modules: [
      'Crop Production',
      'Soil Management',
      'Pest Control',
      'Extension Methods',
      'Farm Record Keeping',
      'Community Engagement',
    ],
  },
  {
    id: 'esc',
    name: 'Environmental Sanitation Certificate',
    shortName: 'ESC',
    category: 'Agriculture & Environment',
    level: 'Certificate',
    duration: '6 months',
    description: 'Learn waste management, water sanitation, and environmental health practices.',
    modules: [
      'Waste Management',
      'Water and Sanitation',
      'Vector Control',
      'Food Hygiene',
      'Environmental Assessment',
      'Community Sanitation',
    ],
  },
  {
    id: 'dag',
    name: 'Diploma in Agriculture',
    shortName: 'DAG',
    category: 'Agriculture & Environment',
    level: 'Diploma',
    duration: '12 months',
    description: 'Comprehensive agricultural training covering crop science, animal husbandry, and farm management.',
    modules: [
      'Crop Science',
      'Animal Husbandry',
      'Soil Science',
      'Agricultural Economics',
      'Farm Management',
      'Agribusiness',
      'Sustainable Agriculture',
      'Field Practicum',
    ],
  },
  
  // Education & Training Programs
  {
    id: 'ece',
    name: 'Early Childhood Education Certificate',
    shortName: 'ECE',
    category: 'Education & Training',
    level: 'Certificate',
    duration: '6 months',
    description: 'Prepare to teach and nurture young children in preschool and daycare settings.',
    modules: [
      'Child Development',
      'Early Learning Methods',
      'Classroom Management',
      'Play-Based Learning',
      'Health and Safety',
      'Parent Communication',
    ],
  },
  {
    id: 'tot',
    name: 'Training of Trainers Certificate',
    shortName: 'TOT',
    category: 'Education & Training',
    level: 'Certificate',
    duration: '3 months',
    description: 'Develop skills to design and deliver effective training programs for adult learners.',
    modules: [
      'Adult Learning Principles',
      'Training Design',
      'Facilitation Techniques',
      'Training Materials Development',
      'Assessment Methods',
      'Training Evaluation',
    ],
  },
  {
    id: 'det',
    name: 'Diploma in Education Technology',
    shortName: 'DET',
    category: 'Education & Training',
    level: 'Diploma',
    duration: '12 months',
    description: 'Learn to integrate technology into teaching and develop digital learning resources.',
    modules: [
      'Educational Technology Foundations',
      'E-Learning Design',
      'Multimedia in Education',
      'Learning Management Systems',
      'Digital Content Creation',
      'Assessment Technology',
      'Emerging EdTech',
      'Capstone Project',
    ],
  },
];

// Summary statistics
export const vocationalStats = {
  totalPrograms: vocationalPrograms.length,
  certificates: vocationalPrograms.filter(p => p.level === 'Certificate').length,
  diplomas: vocationalPrograms.filter(p => p.level === 'Diploma').length,
  categories: vocationalCategories.length,
};
